import React from 'react';

import { Grid, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

import { number, t } from '~/helpers';

function fieldValue(value) {
  return value || '';
}

function ReadOnlyField({ label, value, multiline }) {
  return (
    <TextField
      label={label}
      value={fieldValue(value)}
      variant="outlined"
      fullWidth
      size="small"
      multiline={multiline}
      rows={multiline ? 2 : 1}
      InputLabelProps={{ shrink: true }}
      InputProps={{ readOnly: true }}
    />
  );
}

export default function View({ data }) {
  return (
    <Grid
      container
      spacing={2}
      style={{
        width: '100%',
        margin: 0,
        padding: 8,
      }}
    >
      <Grid item xs={12} md={6}>
        <ReadOnlyField
          label={t('s.configuracao.terminal.nomeposto')}
          value={data?.codigonomeposto || data?.idposto}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <ReadOnlyField
          label={t('s.operacao.afericaoareiasilo.silo')}
          value={
            data?.nomesiloafericaoareiasilo ||
            data?.descricaosiloafericaoareiasilo
          }
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <ReadOnlyField
          label={t('s.operacao.afericaoareiasilo.datahora')}
          value={data?.datahoraafericaoareiasilo}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <ReadOnlyField
          label={t('s.menu.operacao.turno')}
          value={data?.numeroturno || data?.idturno}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <ReadOnlyField
          label="Peso Kg"
          value={number(data?.pesoafericaoareiasilo || 0, '2')}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <ReadOnlyField
          label="Duração s"
          value={data?.duracaoafericaoareiasilo}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <ReadOnlyField
          label="Vazão Kg/s"
          value={number(data?.vazaoafericaoareiasilo || 0, '6')}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <ReadOnlyField
          label={t('s.geral.executante')}
          value={
            data?.nomeusuarioafericaoareiasilo ||
            data?.idusuarioafericaoareiasilo
          }
        />
      </Grid>

      <Grid item xs={12}>
        <ReadOnlyField
          label={t('s.geral.observacao')}
          value={data?.observacaoafericaoareiasilo}
          multiline
        />
      </Grid>
    </Grid>
  );
}

View.propTypes = {
  data: PropTypes.shape({
    codigonomeposto: PropTypes.string,
    datahoraafericaoareiasilo: PropTypes.string,
    descricaosiloafericaoareiasilo: PropTypes.string,
    duracaoafericaoareiasilo: PropTypes.number,
    idposto: PropTypes.number,
    idturno: PropTypes.number,
    idusuarioafericaoareiasilo: PropTypes.number,
    nomesiloafericaoareiasilo: PropTypes.string,
    nomeusuarioafericaoareiasilo: PropTypes.string,
    numeroturno: PropTypes.number,
    observacaoafericaoareiasilo: PropTypes.string,
    pesoafericaoareiasilo: PropTypes.number,
    vazaoafericaoareiasilo: PropTypes.number,
  }),
};

View.defaultProps = {
  data: {},
};

ReadOnlyField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  multiline: PropTypes.bool,
};

ReadOnlyField.defaultProps = {
  value: '',
  multiline: false,
};
